import { SurchargeDisputeDataSchema } from "@redotech/redo-billing-common/surcharge-dispute";
import { AdvancedFilterDataSchema } from "@redotech/redo-views-common/advanced-filters/advanced-filter-data";
import * as z from "zod";

export const getSurchargeDisputesAdmin = {
  name: "getSurchargeDisputesAdmin" as const,
  input: z.object({
    pageNumber: z.number(),
    pageSize: z.number(),
    teamId: z.string().optional(),
    search: z.string().optional(),
    advancedFiltersData: z.array(AdvancedFilterDataSchema).optional(),
  }),
  output: z.object({
    disputes: z.array(SurchargeDisputeDataSchema),
    total: z.number(),
  }),
};
